import React from "react";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { Link } from "react-router-dom";

const PageTitle = (props) => {
  return (
    <>
      <section
        className="page-title-section bg-img "
        style={{
          backgroundImage: `url(${props.bimg})`,
          backgroundSize: "cover",
          position: "relative",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="onBg_layer">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 ">
                <div className="title-info text-white">
                  <h1 className=" ml-5">{props.title}                  </h1>
                  <h1 className="ml-5">   {props.link ?
                    <Link to={props.link} target="_blank" className="text-primary" ><i className="fs-4">Visit Website <i className="fa fa-external-link fs-5"></i></i></Link>
                    : ''}
                  </h1>
                  <br />
                  <p className="text-white Titletop_text ml-5 mr-10 ">
                    {props.desc}
                  </p>
                  <ol className="text-white ml-4 mr-10">
                    {props.descarr &&
                      props.descarr.map((item, index) => (
                        <li key={index}>{item} &nbsp;</li>
                      ))}
                  </ol>
                  <Breadcrumb
                    spacing="4px"
                    separator={<ChevronRightIcon color="gray.500" />}
                    className="bg-transparent text-warning ml-1"
                  >
                    <BreadcrumbItem>
                      <Link to="/">Home</Link>
                    </BreadcrumbItem>
                    {props.prevtitle && (
                      <BreadcrumbItem>
                        <Link
                          to={`/${props.prevtitle}`}
                        >
                          {props.prevtitle}
                        </Link>
                      </BreadcrumbItem>
                    )}
                    <BreadcrumbItem isCurrentPage>
                      <Link to="">{props.page}</Link>
                    </BreadcrumbItem>
                  </Breadcrumb>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PageTitle;
